import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dropdown-host]',
    standalone: false
})
export class DropdownDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
